import React from "react";
import { Link } from "react-router-dom";

// Catches render-time errors so production users never see a blank screen
// or a raw stack trace. The technical error is logged to the console only.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-md mx-auto py-24 px-6 text-center" data-testid="app-error-boundary">
          <div className="font-display text-4xl tracking-tight">Something went wrong</div>
          <p className="text-muted-foreground mt-3">We hit an unexpected error while loading this page. Please try again.</p>
          <div className="mt-6 flex gap-3 justify-center">
            <button onClick={() => window.location.reload()} data-testid="error-reload"
              className="btn-primary h-11 px-6 text-sm font-medium">Reload page</button>
            <Link to="/" data-testid="error-home" className="btn-secondary h-11 px-6 text-sm font-medium inline-flex items-center">Go home</Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
